import { type } from '@/utils/type'

export const AUTH_REQUEST =  type('AUTH_REQUEST')
export const AUTH_USER_REQUEST =  type('AUTH_USER_REQUEST')
export const AUTH_LOGOUT_REQUEST =  type('AUTH_LOGOUT_REQUEST')
export const AUTH_AUTO_LOGOUT_REQUEST =  type('AUTH_AUTO_LOGOUT_REQUEST')
export const AUTH_PASSWORD_REQUEST =  type('AUTH_PASSWORD_REQUEST')
export const AUTH_CHANGE_PASSWORD_REQUEST =  type('AUTH_CHANGE_PASSWORD_REQUEST')
export const AUTH_CREATE_PASSWORD_REQUEST =  type('AUTH_CREATE_PASSWORD_REQUEST')
export const AUTH_CREATE_ACCOUNT_REQUEST = type('AUTH_CREATE_ACCOUNT_REQUEST')
export const AUTH_RESET_STATUS =  type('AUTH_RESET_STATUS')
export const AUTH_SET_REDIRECT_PATH = type('AUTH_SET_REDIRECT_PATH')
export const AUTH_AUTOLOG_REQUEST =  type('AUTH_AUTOLOG_REQUEST')
export const AUTH_UPDATE_USER =  type('AUTH_UPDATE_USER')